window.addEventListener('load', function () {
    const initSlider = () => {
        const $slider = $('.related-products-slider');
        const columnCount = parseInt($slider.data('columns')) || 4;

        if ($slider.length && !$slider.hasClass('slick-initialized')) {
            $slider.slick({
                slidesToShow: columnCount,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                dots: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: { slidesToShow: 3 }
                    },
                    {
                        breakpoint: 768,
                        settings: { slidesToShow: 2 }
                    },
                    {
                        breakpoint: 480,
                        settings: { slidesToShow: 1 }
                    }
                ]
            });
        }
    };

    // Wait until the element is available
    const checkExist = setInterval(() => {
        if (document.querySelector('.related-products-slider')) {
            clearInterval(checkExist);
            initSlider();
        }
    }, 200); // Check every 200ms, stop when found
});
